export enum ParcelServiceLevel {
  Standard = "Standard",
  Expedited = "Expedited",
  International = "International",
  Return = "Return",
}
